import { Fragment, FunctionComponent, useContext, useEffect, useState } from 'react';
import ErrorMessage from '../../../common/error/ErrorMessage';
import { ConfigContext } from '../../configuration/ConfigContext';
import { usePropertyAssociationContext } from '../../propertyAssociation/PropertyAssociationContext';
import Pagination from '../../shared/Pagination';
import { Table, TableHead, TableHeader, TableRow } from '../../shared/Table';
import { usePagination } from '../../shared/usePagination';
import { GetUserAdvertsResponse } from '../models/UserAdvert';
import { getDeletedUserAdverts } from '../userAdvertService';

type Prop = {
    selectAdvertId: (advertId: string) => void;
};

const ListDeletedUserAdverts: FunctionComponent<Prop> = ({ selectAdvertId }) => {
    const { apiBaseUrl } = useContext(ConfigContext);
    const { currentPropertyAssociationId } = usePropertyAssociationContext();
    const [response, setResponse] = useState<GetUserAdvertsResponse | undefined>();
    const [error, setError] = useState<string | undefined>();
    const { currentPage, setCurrentPage, currentItems, totalPages, itemsPerPage } = usePagination(response?.adverts ?? []);

    useEffect(() => {
        getDeletedUserAdverts(apiBaseUrl, currentPropertyAssociationId, setResponse, () => setError('Kunde inte ladda anslagstavla'));
    }, []);

    if (error) {
        return <ErrorMessage message={error} />;
    }

    if (!response) {
        return null;
    }

    if (response.adverts.length === 0) {
        return (
            <p>
                <i>Inga borttagna annonser</i>
            </p>
        );
    }

    return (
        <Fragment>
            <Table withPagination={totalPages > 1}>
                <TableHead>
                    <tr>
                        <TableHeader>Rubrik</TableHeader>
                        <TableHeader className="text-end">Användare</TableHeader>
                    </tr>
                </TableHead>
                <tbody>
                    {currentItems.map(({ advertId, title, user }) => (
                        <TableRow
                            key={advertId}
                            onClick={() => {
                                selectAdvertId(advertId);
                            }}
                        >
                            <td>{title}</td>
                            <td className="text-end">
                                {user.firstName} {user.lastName}
                            </td>
                        </TableRow>
                    ))}
                </tbody>
            </Table>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={response.adverts.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
                ariaLabel="Borttagna annonsers sidnavigering"
            />
        </Fragment>
    );
};

export default ListDeletedUserAdverts;
